<template>
  <div
    class="container__custom-alert"
    ref="container__custom-alert"
  >
    <section
      class="custom-alert"
      ref="custom-alert"
    >
      <h1>{{ customAlertTitle }}</h1>
      <p>{{ customAlertDescription }}</p>
      <article class="custom-alert__button-wrapper">
        <button
          class="custom-alert__button--cancel"
          @click.prevent="customAlertCancelBtnHandler"
        >
          {{ customAlertCancelText }}
        </button>
        <button
          class="custom-alert__button--confirm"
          @click.prevent="customAlertConfirmBtnHandler"
        >
          {{ customAlertConfirmText }}
        </button>
      </article>
    </section>
  </div>
</template>

<script>
import { computedGetters } from '@/utils/vuex-helper';
import { delay } from '@/utils/etc';
export default {
  computed: {
    ...computedGetters([
      'customAlertVisible',
      'customAlertTitle',
      'customAlertDescription',
      'customAlertConfirmText',
      'customAlertCancelText',
      'customAlertConfirmBtnHandler',
      'customAlertCancelBtnHandler'
    ])
  },
  watch: {
    async customAlertVisible(visible) {
      if (visible) {
        if (!this.$refs['container__custom-alert'].classList.contains('open')) {
          this.$refs['container__custom-alert'].classList.add('open');
          await delay(300);
          this.$refs['custom-alert'].classList.add('open');
        }
      } else {
        if (this.$refs['container__custom-alert'].classList.contains('open')) {
          this.$refs['custom-alert'].classList.remove('open');
          await delay(300);
          this.$refs['container__custom-alert'].classList.remove('open');
        }
      }
    }
  }
};
</script>

<style lang='scss'>
.container__custom-alert {
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  display: none;
  background-color: rgba($color: #000000, $alpha: 0.27);

  &.open {
    display: flex;
  }

  .custom-alert {
    margin: auto;
    width: 425px;
    max-width: 425px;
    min-height: 149px;
    padding: 4.5px 20px 9px;
    border-radius: 10px;
    box-shadow: 0 2px 4px 0 rgba(grey, 0.5);
    background-color: #fff;
    padding: 20px;
    display: flex;
    opacity: 0;
    flex-direction: column;
    box-sizing: border-box;
    transform: translateY(-10px);
    transition: opacity 0.2s 0.2s, transform 0.2s 0.2s;

    &.open {
      opacity: 1;
      transform: translateY(0);
    }

    h1,
    p {
      margin: 0;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.8px;
      color: #4a4a4a;
      word-break: break-all;
    }

    h1 {
      font-weight: 500;
      font-size: 17px;
      margin-bottom: 10px;
    }

    p {
      font-weight: normal;
      font-size: 15px;
      margin-bottom: 15px;
    }

    .custom-alert__button-wrapper {
      margin: auto 0 0 auto;
      button {
        cursor: pointer;
        width: 56px;
        height: 42px;
        padding: 0;
        margin: 0;
        border-radius: 8px;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.86px;
        text-align: center;

        &.custom-alert__button--confirm {
          color: #fff;
          background-color: #9b9b9b;
          border: solid 1px #d3d3d3;
          margin-left: 10px;
        }

        &.custom-alert__button--cancel {
          color: #9b9b9b;
          background-color: #fff;
          border: solid 1px #9b9b9b;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .container__custom-alert .custom-alert {
    width: calc(100% - 20px);
  }
}
</style>
